module.exports = "<div>{{ 'home.header' | translate }}</div>";